import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { Header } from "Components/Header";
import { LocalImage } from "Utils/images";
import { Colors } from "Utils/colors";
import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Modal,
  Snackbar,
  Stack,
  Tooltip,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { MenuItem, Select } from "@mui/material";
import LowProducts from "./LowProducts";
import BackOrderedProducts from "./BackOrderedProducts";
import { InFlow } from "Features/services/inFlow.api";
import {
  EditProductInitialValues,
  EditProductInterface,
} from "Model/Product.model";
import CancelIcon from "@mui/icons-material/Cancel";
import { EditProductInventory } from "./EditProductInventory";
import CreateProducts from "./CreateProducts";
import CloseIcon from "@mui/icons-material/Close";

export interface Data {
  productId: string;
  productListingObjectId: string;
  id: number;
  sku: string;
  name: string;
  categoryName: string;
  totalQuantityOnHand?: string;
  unitPrice: string;
  weight: string;
  itemType: string;
  companyClass?: string;
  company_class?: string | any;
  isActive: string;
  action: string;
  quantity: any;
}

// export interface productObject {
//   productId: string;
//   categoryId: string;
//   description: string;
//   isActive: boolean;
//   itemType: string;
//   lastModifiedDateTime: string;
//   name: string;
//   sku: string;
//   standardUomName: string;
//   totalQuantityOnHand: string;
//   weight: string;
//   width: number | null;
// }

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "sku",
    numeric: false,
    disablePadding: true,
    label: "SKU #",
  },
  {
    id: "name",
    numeric: true,
    disablePadding: false,
    label: "Product Name",
  },
  {
    id: "totalQuantityOnHand",
    numeric: true,
    disablePadding: false,
    label: "Qty",
  },
  {
    id: "unitPrice",
    numeric: true,
    disablePadding: false,
    label: "Price",
  },
  {
    id: "categoryName",
    numeric: false,
    disablePadding: false,
    label: "Category",
  },
  {
    id: "weight",
    numeric: true,
    disablePadding: false,
    label: "Weight (lbs)",
  },
  {
    id: "itemType",
    numeric: false,
    disablePadding: false,
    label: "Company Class",
  },
  {
    id: "isActive",
    numeric: false,
    disablePadding: true,
    label: "Updated",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: true,
    label: "Edit",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: true,
    label: "Delete",
  },
];

interface EnhancedTableProps {
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, rowCount, onRequestSort } = props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead sx={{ background: "#e6f2f6" }}>
      <TableRow sx={{ borderRight: "none", borderLeft: "none" }}>
        {headCells.map((headCell) => (
          <TableCell
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              background: "#e6f2f6",
              borderBottom: "none",
              textAlign: "left",
              borderRight: "none",
              borderLeft: "none",
            }}
            key={headCell.id}
            // align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? "none" : "normal"}
            // sortDirection={orderBy === headCell.id ? order : false}
          >
            {/* <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            > */}
            
            {headCell.label}
            {/* {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel> */}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

interface State {
  open: boolean;
  message: string;
  type: "error" | "warning" | "success" | "info";
}

type SnackType = "error" | "warning" | "success" | "info";

type TabType = "all" | "low"  | "outofstock";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
  width: "50%",
  height: "auto",
  overflowX: "hidden",
  overflowY: "scroll",
};

export default function Inventory() {

  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<keyof Data>("sku");
  const [pageNo, setPageNo] = useState(1);
  const [dense, setDense] = useState(false);
  const [selectedTab, setSelectedTab] = useState<TabType>("all");

  let [listProducts, setListProducts] = useState<Data[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [rows, setRows] = useState<Data[]>([]);
  const [totalCount, setTotalCount] = useState(0);

  const [createProductModal, setCreateProductModal] = useState<boolean>(false);
  const [createdProduct, setCreatedProduct] = useState<boolean>(false);

  const [editProductModal, setEditProductModal] = useState(false);
  const [editProduct, setEditProduct] = useState<any>();

  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [deleteProductId, setDeleteProductId] = useState<string>("");

  const [productUpdated, setProductUpdated] = useState<boolean>(false);

  const handleDeleteModalOpen = (productId: string) => {
    setDeleteProductId(productId);
    setConfirmDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setConfirmDeleteModal(false);
  };

  const handleDeleteConfirm = async () => {
    if (deleteProductId !== null) {
      await handleDeleteProduct(deleteProductId);
      setDeleteProductId("");
      handleDeleteModalClose();
    }
  };

  const handleCreateProductOpen = () => {
    setCreateProductModal(true);
  };
  const handleCreateProductClose = () => {
    setCreateProductModal(false);
  };

  const editProductModalOpen = () => setEditProductModal(true);
  const editProductModalClose = () => setEditProductModal(false);

  const [snackbar, setSnackbar] = useState<State>({
    open: false,
    message: "",
    type: "info",
  });

  // const onClickTab = (tab: TabType) => {

  //   const filteredList = listProducts?.filter((item: Data) =>
  //     tab === "low"
  //       ? (item?.inventoryLines[0]?.quantityOnHand?.split(".")[0] || 0) <= 10
  //       : tab === "outofstock"
  //       ? (item?.inventoryLines[0]?.quantityOnHand?.split(".")[0] || 0) == 0
  //       : item
  //   );
  //   setRows(filteredList);

  //   setSelectedTab(tab);
  // };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSnackbar = (
    visible: boolean,
    message: string = "",
    type: SnackType = "info"
  ) => {
    setSnackbar({ ...snackbar, message, type, open: visible });
  };

  const [offset, setOffset] = React.useState(0);

  const paginationOrder = Math.ceil(totalCount / 10) || 0;

  const [searchActive, setSearchActive] = useState<boolean>(false);

  const getCurrentItemsCount = React.useCallback(() => {
    if (searchActive) {
      return offset + rows?.length;
    } else {
      const currentItems = rows?.length;
      if (pageNo < paginationOrder) {
        return pageNo * 10;
      } else {
        return totalCount;
      }
    }
  }, [rows?.length, offset, totalCount, pageNo, paginationOrder, searchActive]);

  // const getCurrentItemsCount = React.useCallback(() => {
  //   const currentItems = rows.length;
  //   if (pageNo < paginationOrder) {
  //     return pageNo * 10;
  //   } else {
  //     return totalCount;
  //   }
  // }, [rows, totalCount, pageNo, paginationOrder]);

  // const getCurrentItemsCount = React.useCallback(() => {

  //   if (offset === 0 && totalCount > 10) return 10;
  //   return offset;
  // }, [offset, rows]);

  const fetchProducts = async (offset: number) => {
    
    try {
      setLoading(true);
    
      const response = await InFlow.instance.listProducts(offset);
      const data = response.data?.productsList;
      setListProducts(data);
      setRows(data);
      setTotalCount(response.data?.count || 0);
    } catch (error: any) {
      handleSnackbar(true, error?.message, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts(offset);
  }, []);

  const fetchLowProducts = async (offset: number) => {
    try {
      setLoading(true);
      const response = await InFlow.instance.lowProducts(offset);
      const data = response.data?.productsList;
      setListProducts(data);
      setRows(data);
      setTotalCount(response.data?.count || 0);
    } catch (error: any) {
      handleSnackbar(true, error?.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchOutOfStockProducts = async (offset: number) => {
    try {
      setLoading(true);
      const response = await InFlow.instance.outofStockProducts(offset);
      const data = response.data?.productsList;
      setListProducts(data);
      setRows(data);
      setTotalCount(response.data?.count || 0);
    } catch (error: any) {
      handleSnackbar(true, error?.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const onClickTab = (tab: TabType) => {
    setSelectedTab(tab);
  };

  useEffect(() => {
    // Fetch data based on the selected tab whenever it changes
    switch (selectedTab) {
      case "all":
        fetchProducts(offset);
        break;
      case "low":
        fetchLowProducts(offset);
        break;
      case "outofstock":
        fetchOutOfStockProducts(offset);
        break;
      default:
        break;
    }
  }, [selectedTab, offset]);

  const handleInputChange = async (value: string) => {
    if (value === "") {
      setSearchActive(false);

      switch (selectedTab) {
        case "all":
          fetchProducts(offset);
          break;
        case "low":
          fetchLowProducts(offset);
          break;
        case "outofstock":
          fetchOutOfStockProducts(offset);
          break;
        default:
          break;
      }

      return;
    }
    try {
      setLoading(true);
      setSearchActive(true);
      const response = await InFlow.instance.searchProducts(50, value);
      const data = response.data?.productsList;
      setListProducts(data);
      setRows(data);
      setTotalCount(response?.data?.count || 0);
      setOffset(0);
    } catch (error) {
      // handleSnackbar(true, error?.message, "error");
      console.error("Something went wrong", error);
    } finally {
      setLoading(false);
    }
  };

  const changePageNo = (no: number) => {
    setPageNo(no);
    const newOffset = (no - 1) * 10;
    setOffset(newOffset);

    // Fetch data based on the selected tab
    switch (selectedTab) {
      case "all":
        fetchProducts(newOffset);
        break;
      case "low":
        fetchLowProducts(newOffset);
        break;
      case "outofstock":
        fetchOutOfStockProducts(newOffset);
        break;
      default:
        break;
    }
  };

  // const [productModal, setProductModal] = useState({
  //   visible: false,
  //   title: "Edit Product",
  // });

  // const [form, setForm] = useState(EditProductInitialValues);

  // const handleProductModal = (
  //   status: boolean,
  //   response: "success" | "cancel" = "cancel",
  //   updatedForm?: EditProductInterface
  // ) => {

  //   if (response === "success") {
  //     // update the product
  //     const updatedList = rows.map((item) => {
  //       if (item.productId === form.productId) {
  //         console.log(form);
  //         return {
  //           ...item,
  //           ...updatedForm,
  //         };
  //       } else {
  //         return item;
  //       }
  //     });
  //     // @ts-ignore

  //     setRows(updatedList);
  //     console.log("updatedList--", updatedList)

  //     setProductModal({
  //       ...productModal,
  //       visible: status,
  //     });
  //     setForm(EditProductInitialValues);
  //   } else {
  //     setForm(EditProductInitialValues);
  //     setProductModal({
  //       ...productModal,
  //       visible: status,
  //     });
  //   }
  // };

  // const editProduct = (row: any) => {

  //   handleProductModal(true);
  //   setForm({
  //     totalQuantityOnHand: row.totalQuantityOnHand as string,
  //     weight: row.weight || "",
  //     productId: row?.productId || row?.productListingObjectId,
  //     name: row.name,
  //     sku: row.sku,
  //     standardUomName: row.standardUomName,
  //     totalQuantityAvailable: row.totalQuantityAvailable,
  //     unitPrice: row.unitPrice,
  //     width: row.width,
  //     itemType: row.itemType,
  //   });
  // };

  const fetchProductToEdit = async (productId: string) => {
    try {
      setLoading(true);
      debugger;
      const response = await InFlow.instance.getSingleEditProduct(productId);
      console.warn("edit response", response.data.data);
      setEditProductModal(true);
      setEditProduct(response.data.data);
      // setRows(response.data.data);
    } catch (error: any) {
      handleSnackbar(true, error?.message, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (productUpdated || createdProduct) {
      if (selectedTab === "all") {
        fetchProducts(offset);
      } else if (selectedTab === "low") {
        fetchLowProducts(offset);
      } else if (selectedTab === "outofstock") {
        fetchOutOfStockProducts(offset);
      }
      setProductUpdated(false);
    }
  }, [productUpdated, createdProduct]);

  const handleDeleteProduct = async (productId: any) => {
    debugger;
    const payload  = {
      productId: productId,
      isActive: false,
    }
    try {
      setLoading(true);
      const response = await InFlow.instance.deleteProduct(payload);
      handleSnackbar(true, "Successfully Deleted");

      if (selectedTab === "all") {
        fetchProducts(offset);
      } else if (selectedTab === "low") {
        fetchLowProducts(offset);
      } else if (selectedTab === "outofstock") {
        fetchOutOfStockProducts(offset);
      }
    } catch (error: any) {
      handleSnackbar(true, error?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="main"
      sx={{
        backgroundImage: `url(${LocalImage.contactBg})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: `${Colors.white}`,
        backgroundSize: "20% auto",
        backgroundPosition: "right bottom",
        flex: 1,
        overflow: "auto",
        px: 3,
        pt: 15,
        pb: 8,
      }}
    >
      <Header
        title="Inventory Management"
        subTitle="View, Track and Manage Inventory Details"
        btnName="New Inventory"
        onButtonClick={handleCreateProductOpen}
        onInputChange={handleInputChange}
      />

      <Grid container>
        <Grid sm={12} lg={9}>
          <Box sx={{ width: "100%" }} className="table-top-border">
            <Grid container sx={{ pb: 1 }}>
              <Grid sm={12}>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="outlined"
                    className={`button-style01 ${
                      selectedTab === "all" ? "button-style01-active" : ""
                    }`}
                    onClick={() => {
                      setSelectedTab("all");
                      setPageNo(1); // Reset to first page
                      setOffset(0); // Reset offset
                      fetchProducts(offset);
                    }}
                  >
                    All Products
                  </Button>

                  <Button
                    variant="outlined"
                    className={`button-style01 ${
                      selectedTab === "low" ? "button-style01-active" : ""
                    }`}
                    onClick={() => {
                      onClickTab("low");
                      setPageNo(1); // Reset to first page
                      setOffset(0); // Reset offset
                      fetchLowProducts(offset);
                    }}
                  >
                    Low Products
                  </Button>

                  {/* <Button
                    variant="outlined"
                    className={`button-style01 ${
                      selectedTab === "backorders"
                        ? "button-style01-active"
                        : ""
                    }`}
                    onClick={() => onClickTab("backorders")}
                  >
                    Backorders
                  </Button> */}
                  <Button
                    variant="outlined"
                    className={`button-style01 ${
                      selectedTab === "outofstock"
                        ? "button-style01-active"
                        : ""
                    }`}
                    onClick={() => {
                      onClickTab("outofstock");
                      setPageNo(1); // Reset to first page
                      setOffset(0); // Reset offset
                      fetchOutOfStockProducts(offset);
                    }}
                  >
                    Out of Stock
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2, boxShadow: "none" }}>


            <TableContainer sx={{ maxHeight: 500 }}>

                <Table
                  stickyHeader
                  sx={{ minWidth: 750}}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                >

                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={rows?.length}
                  />

                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontWeight: "bolder",
                              height: "70vh",
                            }}
                          >
                            <CircularProgress />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <>
                        {rows?.length > 0 ? (
                          rows.map((row, index) => (
                            <TableRow
                              hover
                              role="checkbox"
                              aria-checked={"mixed"}
                              tabIndex={-1}
                              key={row.id}
                              sx={{ cursor: "pointer" }}
                            >
                              <TableCell
                                component="th"
                                scope="row"
                                padding="none"
                                align="left"
                              >
                                {row.sku}
                              </TableCell>

                              <TableCell
                                align="left"
                                sx={{
                                  fontSize: "12px",
                                  cursor: "pointer",
                                  "&:hover": {
                                    color: "#007ca4",
                                  },
                                }}
                                onClick={() =>
                                  fetchProductToEdit(
                                    row.productId || row.productListingObjectId
                                  )
                                }
                              >
                                {row?.name || "-"}
                              </TableCell>

                              <TableCell align="left">
                                {row.quantity
                                  ? parseFloat(row.quantity).toFixed(
                                      0
                                    )
                                  : "-"}
                              </TableCell>
                              <TableCell align="left">
                                {row.unitPrice
                                  ? `$${parseFloat(row.unitPrice).toFixed(2)}`
                                  : "-"}
                              </TableCell>

                              <TableCell align="left">
                                {row.categoryName || "-"}
                              </TableCell>

                              <TableCell align="left">
                                {row.weight
                                  ? parseFloat(row.weight).toFixed(2)
                                  : "-"}
                              </TableCell>
                              <TableCell align="left">
                                {row?.company_class || "NAN"}
                              </TableCell>
                              <TableCell align="left">
                                {row.isActive ? "Exists" : "Not Exists"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ color: "orange" }}
                                onClick={() =>
                                  fetchProductToEdit(
                                    row.productId || row.productListingObjectId
                                  )
                                }
                              >
                                Edit
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ color: "red" }}
                                onClick={() =>
                                  handleDeleteModalOpen(
                                    row.productId || row.productListingObjectId
                                  )
                                }
                              >
                                Delete
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={8} align="center">
                              <p>No Data Found</p>
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mt: 3,
                }}
              >
                <Typography
                  variant="body1"
                  component={"body"}
                  color={"#717579"}
                  fontSize={"10px"}
                >
                  Showing {getCurrentItemsCount()} from {totalCount} entries
                </Typography>

                {paginationOrder > 0 ? (
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Box
                      onClick={() => {
                        if (pageNo > 1) {
                          changePageNo(pageNo - 1);
                        }
                      }}
                      sx={{
                        backgroundColor: "#007CA4",
                        padding: "8px 8px 0px 8px",
                        color: "#fff",
                        borderTopLeftRadius: "6px",
                        borderBottomLeftRadius: "6px",
                      }}
                    >
                      <ArrowBackIosIcon sx={{ fontSize: "14px", mt: "2px" }} />
                    </Box>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={pageNo}
                      inputProps={{
                        "aria-label": "Without label",
                        sx: { padding: "6px 20px !important" },
                      }}
                      onChange={(event) => {
                        changePageNo(event.target.value as number);
                      }}
                      fullWidth
                      size="small"
                      placeholder="1"
                      IconComponent={() => null}
                    >
                      {new Array(paginationOrder).fill(0).map((_, index) => (
                        <MenuItem value={index + 1} key={index}>
                          {index + 1}
                        </MenuItem>
                      ))}
                    </Select>
                    <Box
                      onClick={() => {
                        if (pageNo < paginationOrder) {
                          changePageNo(pageNo + 1);
                        }
                      }}
                      sx={{
                        backgroundColor: "#007CA4",
                        padding: "8px 8px 0px 8px",
                        color: "#fff",
                        borderTopRightRadius: "6px",
                        borderBottomRightRadius: "6px",
                      }}
                    >
                      <ArrowForwardIosIcon
                        sx={{ fontSize: "14px", mt: "2px" }}
                      />
                    </Box>
                  </Box>
                ) : null}
              </Box>
            </Paper>
          </Box>
        </Grid>

        <Grid sm={12} lg={3}>
          <Box sx={{ pl: 1 }}>
            <Box>
              <LowProducts />
            </Box>
            <Box>{/* <BackOrderedProducts /> */}</Box>
          </Box>
        </Grid>
      </Grid>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbar.open}
        onClose={() => handleSnackbar(false)}
        autoHideDuration={2500}
      >
        <Alert
          onClose={() => handleSnackbar(false)}
          severity={snackbar.type}
          sx={{
            width: "100%",
            backgroundColor: Colors.secondary,
            color: Colors.white,
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Dialog open={createProductModal}>
        <Grid container spacing={2} alignItems={"center"}>
          <Grid item md={11}>
            <Box display="flex" justifyContent="center">
              <DialogTitle>Create Product</DialogTitle>
            </Box>
          </Grid>
          <Grid item md={1}>
            <Tooltip title="Cancel" style={{ marginRight: 8, float: "right" }}>
              <IconButton onClick={handleCreateProductClose}>
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <DialogContent>
          <CreateProducts
            closeModal={handleCreateProductClose}
            setCreatedProduct={setCreatedProduct}
          />
        </DialogContent>
      </Dialog>

      {/* <Dialog open={productModal.visible}>
        <Grid container spacing={2} alignItems={"center"}>
          <Grid item md={11}>
            <Box display="flex" justifyContent="center">
              <DialogTitle>{productModal.title}</DialogTitle>
            </Box>
          </Grid>
          <Grid item md={1}>
            <Tooltip title="Cancel" style={{ marginRight: 8, float: "right" }}>
              <IconButton onClick={() => handleProductModal(false)}>
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <DialogContent>
          <EditProduct
            formType={productModal.title}
            initialValues={form}
            closeModal={(
              response: "success" | "cancel",
              updatedForm: EditProductInterface
            ) => handleProductModal(false, response, updatedForm)}
          />
        </DialogContent>
      </Dialog>  */}

      <Modal
        open={editProductModal}
        onClose={editProductModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <>
          <Box sx={style} className="modal-scroll-content">
            <EditProductInventory
              closeModal={editProductModalClose}
              product={editProduct}
              setProductUpdated={setProductUpdated}
            />
          </Box>

          <Button
            sx={{
              backgroundColor: "#FFAA2A",
              padding: "8px 0px",
              float: "right",
              right: "23.5%",
              top: "1.5%",
              "&:hover": {
                backgroundColor: "#E69927",
              },
            }}
            onClick={editProductModalClose}
          >
            <CloseIcon sx={{ fontSize: "32px", color: "#fff" }} />
          </Button>
        </>
      </Modal>

      <Dialog
        open={confirmDeleteModal}
        onClose={handleDeleteModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteModalClose}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
